import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';

interface loginPayload {
  token: string;
}

const initializer = () => {
    if(localStorage.getItem("token") !== null) {
        return {
            authenticated: true,
            token: localStorage.getItem("token"),
        };
    }
    else { return {
            authenticated: false,
        };
    }
}


const usertokenSlice = createSlice({
  name: 'usertoken',
  initialState: initializer(),
  reducers: {
    login(state, action: PayloadAction<loginPayload>) {
        state.authenticated = true;
        state.token = action.payload.token;
        localStorage.setItem("token", action.payload.token)
    },
    logout(state, action: PayloadAction<void>) {
        localStorage.removeItem("token");
        state = {authenticated: false};
    },
  },
});

const logoutf =
  (payload: void) =>
  (dispatch: AppDispatch): void => {
    dispatch(usertokenSlice.actions.logout());
  };

const loginf =
  (payload: loginPayload) =>
  (dispatch: AppDispatch): void => {
    dispatch(usertokenSlice.actions.login(payload));
  };

export const { logout } = usertokenSlice.actions;
export { loginf, logoutf };
export default usertokenSlice.reducer;
